import React from 'react';
import { ipaToFeatures, IpaType } from '../../phonemes/ipa';
import { segmentPhonemes } from '../../phonemes/segmentPhonemes';

interface SegmentFeaturesProps {
  readonly segment: IpaType;
}

/** show all the features for each phoneme in a segment like õ̞ãˤ */
export function SegmentFeatures(props: SegmentFeaturesProps) {
  const pieces = segmentPhonemes(props.segment, 'ipa', 'all-aff');
  const features = pieces.phonemes.map(p => { return { p: p.phoneme, f: ipaToFeatures(p.phoneme) } });

  /*
  <tr> <th>phoneme1</th> <td>feature1</td> <td>feature2</td> </tr>
  <tr> <th>phoneme2</th> <td>feature1</td> </tr>
  */
  return (<table>
    <tbody>
      {features.map((m, i) => (
        <tr key={i}>
          <th>{m.p}</th>
          {m.f?.map((f, j) => (
            <td key={`${i}-${j}`}>{f}</td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>);
}
